// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class HceTabControlService {
  private tabChangeSubject = new Subject<number>();
  tabChange$ = this.tabChangeSubject.asObservable();

  requestChange(index: number) {
    this.tabChangeSubject.next(index);
  }
}